<template>
  <div>
    <div v-if="!recibo.esPolizaInternauto" :class="reciboPendiente">
      {{ recibo.fecRecibo | dateDDMMYYYY }} ({{
         recibo.importeNeto | currencyEUR
      }})
    </div>
     <div v-else :class="reciboPendiente">
      {{ recibo.fecRecibo | dateDDMMYYYY }} 
    </div>
  </div>
</template>
<script>
export default {
  props: {
    recibo: {
      type: Object,
      required: true
    }
  },

  computed: {
    reciboPendiente() {
      let fecRec = new Date(this.recibo.fecRecibo);
      let hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return this.recibo.pendiente && this.recibo.pagable && fecRec < hoy
        ? "pendiente"
        : "defecto";
    }
  }
};
</script>

<style lang="scss" scoped>
.pendiente {
  color: $naranjaMMT;
}
.defecto {
  color: white;
}
</style>
